export default {"src":"/_next/static/media/luxury-sedan.eb375f96.svg","height":150,"width":251,"blurWidth":0,"blurHeight":0};